import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BnNgIdleService } from 'bn-ng-idle';

// PrimeNG components
import {TabViewModule} from 'primeng/tabview';
import {ButtonModule} from 'primeng/button';
import {ChartModule} from 'primeng/chart';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {TableModule} from 'primeng/table';
import {ToolbarModule} from 'primeng/toolbar';
import {DialogModule} from 'primeng/dialog';
import {CalendarModule} from 'primeng/calendar';
import {InputNumberModule} from 'primeng/inputnumber';
import {TooltipModule} from 'primeng/tooltip';
import {DropdownModule} from 'primeng/dropdown';
import {MessageService} from 'primeng/api';
import {ToastModule} from 'primeng/toast';
import {InputTextModule} from 'primeng/inputtext';
import {InputSwitchModule} from 'primeng/inputswitch';
import {PasswordModule} from 'primeng/password';
import {MenuModule} from 'primeng/menu';
import {MenuItem} from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

// Our components
import { AppComponent } from './app.component';
import { CellPipe } from './cell.pipe';
import { GridComponent } from './grid/grid.component';
import { D3matrixComponent } from './d3matrix/d3matrix.component';
import { D3pieComponent } from './d3pie/d3pie.component';
import { D3circlesComponent } from './d3circles/d3circles.component';
import { D3barComponent } from './d3bar/d3bar.component';
import { MainComponent } from './main/main.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ProfileComponent } from './profile/profile.component';
import { HomeComponent } from './home/home.component';
import { AppRoutingModule } from './app-routing.module';
import { Globals } from './globals';
import { authInterceptorProviders } from './_helpers/auth.interceptor';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ComparisonComponent } from './comparison/comparison.component';
import { YoyComponent } from './yoy/yoy.component';
import { MapComponent } from './map/map.component';
import {PasswordComponent} from './password/password.component';
import { AdminComponent } from './admin/admin.component';

@NgModule({
  declarations: [
    AppComponent,
    GridComponent,
    CellPipe,
    D3matrixComponent,
    D3pieComponent,
    D3circlesComponent,
    D3barComponent,
    MainComponent,
    LoginComponent,
    RegisterComponent,
    PasswordComponent,
    ProfileComponent,
    HomeComponent,
    PageNotFoundComponent,
    ComparisonComponent,
    YoyComponent,
    MapComponent,
    AdminComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,

    TabViewModule,
    ButtonModule,
    ChartModule,
    AutoCompleteModule,
    TableModule,
    ToolbarModule,
    DialogModule,
    CalendarModule,
    InputNumberModule,
    TooltipModule,
    DropdownModule,
    ToastModule,
    AppRoutingModule,
    InputTextModule,
    InputSwitchModule,
    PasswordModule,
    MenuModule,
    ConfirmDialogModule
  ],
  providers: [authInterceptorProviders, Globals, BnNgIdleService, MessageService],
  bootstrap: [AppComponent]
})
export class AppModule { }
